var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4798_73381)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4798_73381",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4798_73381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 4C13.1045 4 13.9999 3.10457 13.9999 2C13.9999 0.89543 13.1045 0 11.9999 0C10.8954 0 10 0.89543 10 2C10 3.10457 10.8954 4 11.9999 4Z",
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 14.0002C13.1045 14.0002 13.9999 13.1048 13.9999 12.0002C13.9999 10.8956 13.1045 10.0002 11.9999 10.0002C10.8954 10.0002 10 10.8956 10 12.0002C10 13.1048 10.8954 14.0002 11.9999 14.0002Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 23.9998C13.1045 23.9998 13.9999 23.1044 13.9999 21.9998C13.9999 20.8952 13.1045 19.9998 11.9999 19.9998C10.8954 19.9998 10 20.8952 10 21.9998C10 23.1044 10.8954 23.9998 11.9999 23.9998Z",
    fill: "#CurrentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4798_73381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreOutlined);
export default __webpack_public_path__ + "static/media/MoreOutlined.15bca77d6591ebd8e2f99dc444ba2244.svg";
export { ForwardRef as ReactComponent };